export function isURL(link?: Nullable<string>): boolean {
  if (!link) {
    return false;
  }

  const parsedLink = link.trim().replaceAll('\n', '');

  if (!/^[a-z0-9]+:\/\//.test(parsedLink)) {
    return false;
  }

  try {
    new URL(parsedLink);

    return true;
  } catch (e) {
    return false;
  }
}
